import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
	faBox,
	faBriefcase,
	faFileContract,
	faFileInvoiceDollar,
} from '@fortawesome/free-solid-svg-icons';

export type WorkflowCategoryId = 'clients' | 'suppliers';

export type WorkflowCategory = {
	id: WorkflowCategoryId;
	title: string;
	short: string;
	badgeClass: string;
};

/** Même ordre que le menu : clients, puis fournisseurs. */
export const workflowCategories: WorkflowCategory[] = [
	{
		id: 'clients',
		title: 'Clients',
		short: 'GRC',
		badgeClass: 'bg-green-200 text-green-800',
	},
	{
		id: 'suppliers',
		title: 'Fournisseurs',
		short: 'GRF',
		badgeClass: 'bg-purple-200 text-purple-800',
	},
];

export type WorkflowGroup = {
	id: string;
	category: WorkflowCategoryId;
	title: string;
	icon: IconDefinition;
	match: (code: string) => boolean;
};

/** Sous-groupes dans l'ordre du menu gauche. */
export const workflowGroups: WorkflowGroup[] = [
	{
		id: 'quotes',
		category: 'clients',
		title: 'Devis',
		icon: faFileContract,
		match: (code) => code.startsWith('quote_version.'),
	},
	{
		id: 'customerOrders',
		category: 'clients',
		title: 'Commandes',
		icon: faBox,
		match: (code) => code.startsWith('customer_order.'),
	},
	{
		id: 'projects',
		category: 'clients',
		title: 'Affaires',
		icon: faBriefcase,
		match: (code) => code.startsWith('project.'),
	},
	{
		id: 'customerInvoices',
		category: 'clients',
		title: 'Factures',
		icon: faFileInvoiceDollar,
		match: (code) => code.startsWith('customer_invoice.'),
	},
	{
		id: 'orders',
		category: 'suppliers',
		title: 'Commandes',
		icon: faBox,
		match: (code) =>
			code.startsWith('order_version.') ||
			code.startsWith('order.') ||
			code.startsWith('order_line.'),
	},
	{
		id: 'supplierInvoices',
		category: 'suppliers',
		title: 'Factures',
		icon: faFileInvoiceDollar,
		match: (code) => code.startsWith('supplier_invoice.'),
	},
];

export function groupForRule(code: string): WorkflowGroup | undefined {
	return workflowGroups.find((group) => group.match(code));
}
